import axios from 'axios';
import useAuthStore from '../../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

// Get all advertisements
export const getAllAdvertisements = async () => {
    const response = await api.get('/advertisements');
    return response.data;
  };
  

// Get advertisements by category
export const getAdvertisementsByCategory = async (category) => {
  const response = await api.get(`/advertisements/category/${category}`);
  return response.data;
};

// Get advertisements by category
export const getAdvertisementsByPage = async (page) => {
    const response = await api.get(`/advertisements/page/${page}`);
    return response.data;
  };

// Create a new advertisement
export const createAdvertisement = async (advertisementData) => {
    // If advertisementData is a FormData object, use multipart/form-data
    if (advertisementData instanceof FormData) {
      const response = await api.post('/advertisements', advertisementData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    }
  
    // If it's a regular object, use application/json
    const response = await api.post('/advertisements', advertisementData);
    return response.data;
  };
  

// Update an existing advertisement
export const updateAdvertisement = async ({ id, ...advertisementData }) => {
  const response = await api.put(`/advertisements/${id}`, advertisementData);
  return response.data;
};

// Delete an advertisement
export const deleteAdvertisement = async (id) => {
  const response = await api.delete(`/advertisements/${id}`);
  return response.data;
};